<div class="empty-state">
  <div class="empty-state-icon mb-2">
    <img [src]="iconPath" [alt]="title" />
  </div>
  <h3 class="empty-state-title">{{ title }}</h3>
  <p class="empty-state-message">{{ message }}</p>
</div>